// Centralized constants for Best Deal Suggestion logic.
// Moving hard-coded IDs and default values here keeps algorithms unchanged while reducing duplication.

// DBS promo: fixed exact-match ids shortcut
export const DBS_FIXED_IDS = [181, 186, 187, 188, 196, 586, 644, 665, 668, 671, 695, 701, 719, 822, 823];
export const DBS_FIXED_ANY_THREE_IDS = [196, 719, 668];
export const DBS_FIXED_ANY_FIVE_CANDIDATES = [186, 187, 188, 644, 665, 695, 822, 823];

// Bundle IDs for Any-Three and Any-Five promos
export const DBS_ANY_THREE_BUNDLE_ID = 4;
export const DBS_ANY_FIVE_BUNDLE_ID = 5;
export const SUPPORT_ANY_THREE_BUNDLE_ID = 2;
export const SUPPORT_ANY_FIVE_BUNDLE_ID = 3;

// Default promo prices (fallback if not present in suggestions)
export const ANY_THREE_DEFAULT_PRICE = 700;
export const ANY_FIVE_DEFAULT_PRICE = 1000;

// Bundle quantities for plan-and-save promos
export const ANY_FIVE_QUANTITY = 5; // 5-for-1000
export const ANY_THREE_QUANTITY = 3; // 3-for-700
export const ANY_FIVE_PLUS_THREE = ANY_FIVE_QUANTITY + ANY_THREE_QUANTITY; // 8 = 5 + 3

// Special pricing rules
export const HEAVY_METAL_TEST_ID = 181;
export const HEAVY_METAL_SPECIAL_PRICE = 60;
export const HEAVY_METAL_VW_PRICE_THRESHOLD = 199;
// New VW beta pricing rules
export const HEAVY_METAL_SPECIAL_PRICE_NEW_VW_BETA = 70;
export const HEAVY_METAL_VW_PRICE_THRESHOLD_NEW_VW_BETA = 300;

// ID groups used in bundleUtils filtering logic
export const TOTAL_TOX_TRIO = [719, 196, 181];
export const TOTAL_TOX_WITH_PFAS = [719, 196, 181, 674];
export const TOTAL_TOX_WITH_OA = [719, 196, 181, 197];
export const TOTAL_TOX_WITH_PFAS_OA = [719, 196, 181, 197, 674];
export const GUT_ZOOMERS = [186, 187, 188];
export const GUT4_ZOOMERS = [837, 838, 839];
export const GUT_PLUS_OA = [186, 187, 188, 197];
export const GUT4_PLUS_OA = [837, 838, 839, 197];
export const OA_NT = [197, 193];
export const OA_MYCOTOX = [197, 719];
export const SH_NT = [841, 193];
export const GUT4_NT = [837, 838, 839, 193];
